<script lang="ts">
    import TopBarActions from './TopBarActions.svelte';
    import '$src/tailwind.css';
    import { openChat, exitGame, toggleGameFullScreen } from './gameControls';
    import type { VoidFunction } from '$src/lib/common';
    import { spineBus } from '$src/lib/services/gatekeeper/MessageBus';
    import type { GameLaunchPayloads } from '@casumo/fabric-fundamentals';
    import { onMount } from 'svelte';
    import { showSomeElementsForNewerAppVersions } from './utils';
    import type { TWordpressFabricInGameTranslations } from '$src/lib/services/wordpress/types';

    export let inGameTranslations: TWordpressFabricInGameTranslations;

    let gameElement: HTMLElement | undefined;
    let show = false;
    let backgroundImageUrl = '';

    const toggleShow = () => {
        show = !show;
        spineBus.publish('drawer', { kind: show ? 'open' : 'close' });
    };
    const handleToggleGameFullScreen: VoidFunction = () => toggleGameFullScreen(gameElement);
    const handleOpenChat: VoidFunction = () => openChat();
    const handleExitGame: VoidFunction = () => exitGame();

    onMount(() => {
        const unsubscribe = spineBus.subscribe('launch', (payload: GameLaunchPayloads) => {
            if (payload.kind === 'in-game-background') {
                backgroundImageUrl = payload.backgroundImage;
            }
        });

        return () => unsubscribe();
    });

    const showDepositMfe = showSomeElementsForNewerAppVersions();
</script>

<div
    class="flex h-dvh flex-col from-purple-60/20 to-purple-80/40 bg-cover bg-center bg-no-repeat"
    class:bg-gradient-to-r={!backgroundImageUrl}
    style={backgroundImageUrl ? `background-image: url('${backgroundImageUrl}')` : ''}
>
    <slot name="rg-bar" />
    <div class="relative flex flex-1 flex-col desktop-l:gap-sm desktop-l:p-sm desktop-l:pb-0">
        <nav class="flex items-center gap-md" data-testid="in-game-top-nav-bar">
            <button
                on:click={toggleShow}
                class="absolute top-0 z-[2] ml-sm mt-3xs h-2xl w-2xl flex-shrink-0 desktop-l:relative desktop-l:m-0"
            >
                <slot name="in-game-profile-icon">.</slot>
            </button>

            <div
                class="flex h-2xl w-full justify-between bg-grey-90/75 p-2xs pr-0 text-white desktop-l:h-auto desktop-l:justify-end desktop-l:rounded-md"
            >
                <div
                    class="flex flex-1 items-center justify-end gap-2xs pr-2xs desktop-l:justify-start"
                >
                    <slot name="gameplay-rg-bar" />
                </div>
                <div class="hidden desktop-l:flex">
                    {#if showDepositMfe}
                        <slot name="wallet-balance-in-game" />
                    {/if}
                    <TopBarActions
                        {inGameTranslations}
                        onToggleGameFullScreen={handleToggleGameFullScreen}
                        onOpenChat={handleOpenChat}
                        onExitGame={handleExitGame}
                    >
                        <slot name="likes-counter" slot="likes-counter" />
                    </TopBarActions>
                </div>
            </div>
        </nav>
        <main class="relative h-full bg-grey-50/50 desktop-l:rounded" bind:this={gameElement}>
            <slot name="launcher" />
        </main>

        <div class="m-auto flex w-full flex-col">
            <slot name="game-info-bar" />
        </div>

        <div
            class="{show
                ? 'flex'
                : 'hidden'} absolute left-0 top-0 h-full w-full flex-col gap-2xs from-white/95 via-white/10 via-40% to-white/0 to-50% px-sm pt-[64px] backdrop-blur-[2px] desktop-l:max-w-[290px] desktop-l:bg-gradient-to-br desktop-l:pt-[90px] desktop-l:backdrop-blur-0"
            data-testid="in-game-drawer"
        >
            <div
                class="dekstop-l:mx-0 mx-auto flex w-full max-w-[442px] flex-col gap-xs overflow-y-auto"
            >
                <slot name="in-game-adventure-widget" />
                {#if showDepositMfe}
                    <div
                        class="mx-auto flex w-full flex-col rounded-lg bg-grey-90 p-xs desktop-l:hidden"
                    >
                        <slot name="wallet-balance-in-game" />
                    </div>
                {/if}
                <div
                    class="mx-auto flex w-full flex-col rounded-lg bg-grey-90 p-xs desktop-l:hidden"
                >
                    <TopBarActions
                        {inGameTranslations}
                        onToggleGameFullScreen={handleToggleGameFullScreen}
                        onOpenChat={handleOpenChat}
                        onExitGame={handleExitGame}
                    >
                        <slot name="likes-counter" slot="likes-counter" />
                    </TopBarActions>
                </div>
                <slot name="in-game-recent-valuable" />
                <slot name="in-game-ridabodo-widget" />
            </div>
        </div>
    </div>
</div>
<slot name="session-configuration" />
<slot name="ridabodo-invite-pop-up" />
